import { LOADING_SET } from "../actions/actionType";

const initialState = {
	loading: false,
};

export default function userReducers(state = initialState, action) {
	switch (action.type) {
		case LOADING_SET:
			return {
				...state,
				loading: action.payload,
			};
		default:
			return {
				...state,
			};
	}
}
